import {createTheme} from '@material-ui/core/styles'

const mainTheme = createTheme({
  typography: {
    h1: {
      fontSize: '96px',
      lineHeight: '112px',
    },
    h2: {
      fontSize: '60px',
      lineHeight: '72px',
    },
    h3: {
      fontSize: '48px',
      lineHeight: '56px',
    },
    h4: {
      fontSize: '34px',
      lineHeight: '42px',
    },
    h5: {
      fontSize: '24px',
      lineHeight: '32px',
    },
    h6: {
      fontSize: '20px',
      lineHeight: '32px',
    },
    subtitle1: {
      fontSize: '16px',
      lineHeight: '28px',
    },
    subtitle2: {
      fontSize: '14px',
      lineHeight: '22px',
    },
    body1: {
      fontSize: '16px',
      lineHeight: '24px',
    },
    body2: {
      fontSize: '14px',
      lineHeight: '20px',
    },
    caption: {
      fontSize: '12px',
      lineHeight: '20px',
    },
    overline: {
      fontSize: '12px',
      lineHeight: '32px',
    },
  },
  palette: {
    primary: {
      main: '#333DCB',
      dark: '#303F9F',
      light: '#7986CB',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#F50057',
      dark: '#C51162',
      light: '#FF4081',
      contrastText: '#FFFFFF',
    },
    text: {
      primary: '#000000',
      secondary: 'rgba(0, 0, 0, 0.6)',
      disabled: 'rgba(0, 0, 0, 0.26)',
    },
    action: {
      active: 'rgba(0, 0, 0, 0.54)',
      hover: 'rgba(0, 0, 0, 0.04)',
      disabled: 'rgba(0, 0, 0, 0.26)',
      selected: 'rgba(0, 0, 0, 0.08)',
      focus: 'rgba(0, 0, 0, 0.12)',
      disabledBackground: 'rgba(0, 0, 0, 0.12)',
    },
    error: {
      main: '#F44336',
      dark: '#D32F2F',
      light: '#E57373',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#FF9800',
      dark: '#F57C00',
      light: '#FFB74D',
      contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    info: {
      main: '#2196F3',
      dark: '#1976D2',
      light: '#64B5F6',
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#4CAF50',
      dark: '#388E3C',
      light: '#81C784',
      contrastText: '#FFFFFF',
    },
  },
})

export default mainTheme
